import { render } from "./table-order-top.vue?vue&type=template&id=e3ed537e&lang=pug"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__